export default {

  headline: 'SIEGENIA Mediacenter',
  search_info: 'What are you looking for?',
  back: 'back',
  no_results: ' No results found. Please check the search query.',
  service: {
    downloads: 'Documents',
    videos: 'Videos',
    faq: 'FAQ'
  },
  service_search: {
    category_placeholder: "Filter by category"
  },
  service_download: {
    select_info: 'Please choose your search area',
    select_productgroup: 'Select product group',
    select_product: 'Select Product',
    select_type: 'Select Media',
    option_language: "language",
    types: {
      tec_info: 'Technical information',
      installation: 'Assembly instructions',
      planning: 'Planning documents',
      catalog: 'Brochure',
      order_forms: 'Order forms',
      maintenance: 'Maintenance, operation, care instructions',
      construction_drawings: 'Construction drawings',
      software: 'Software',
      certificate: 'Certificate ',
      press: 'Press & Marketing documents',
      videos: 'Video',
      undefined: 'Other',
      commercial: 'Commercial',
      product_video: 'Product Video',
      operating: 'Operating',
      'function': 'Function',
      'assembly': 'Assembly',
      'installation_video': 'Installation',
      'assembly_instructions': 'Assembly instructions',
      'brochure': 'Brochure',
      'tec_catalog': 'Technical catalogues',
      'tec_sheet': 'Technical data sheets',
      'usage_charts': 'Application Diagrams',
      'profile_sheet': 'Profile data sheets',
      'operations_manual': 'Operating and maintenance instructions',
      hardware_info: 'Fitting information',
      'installation_suggestion' : 'Assembly proposal',
      'general' : 'General',
      'troubleshooting' : 'Troubleshooting',
      "smarthome:general" : 'General',
      'smarthome:installation' : 'Installation',
      'smarthome:troubleshooting' : 'Troubleshooting',
      'smarthome:startup' : 'Commissioning',
      'smarthome:operating' : 'Operation',
      'order' : 'Order',
  },
    filter_sorting: {
      filter: "Filter",
      sorting: "Sort by",
      asc: "Title ascending (A-Z)",
      desc: "Title descending (Z-A)",
      date_asc: "Date oldest first",
      date_desc: "Date newest first",
      relevance: "Relevance",
      facet_headline: "Filter Search Results",
      facet_filter_lang: "Languages",
      facet_filter_type_id: "type",
      facet_filter_level_0: "Category",
      filter_remove: "Reset filter",
      show_hide: "Display filter",
    },
    result: {
      count_media: "Media",
      show_results: "Show results",
      preview_type_catalog: "HTML",
      lang_not_available: "Currently not available in your language",
      version_info: "This link leads to the latest version of the documentation. If you need an older version, please contact your SIEGENIA customer service representative."
    }
  }

};
